import "../../components/common/Tables/DataTable.css";
import "./NewsPage.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../redux/store";
import Header from "../../components/common/Header/Header";
import { fetchMyPromos } from "../../redux/actions/promos.actions";
import { fetchMyNotifications } from "../../redux/actions/notifications.actions";
import PromosList from "./components/PromosList";
import NotificationsList from "./components/NotificationsList";
import { BellIcon, GiftIcon } from "../../components/common/Icons/Icons";

const NewsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tab, setTab] = useState(0);
  const user = useSelector((state: RootState) => state.user.data);

  const promoCount = user?.active_promo_count ?? 0;
  const unreadNotifCount = user?.unread_notification_count ?? 0;

  useEffect(() => {
    if (tab === 0) {
      dispatch(fetchMyPromos(searchParams.toString()));
    } else {
      dispatch(fetchMyNotifications(searchParams.toString()));
    }
  }, [dispatch, searchParams, tab]);

  // Each tab starts on its first page (the page number used to carry over from the other tab)
  const switchTab = (next: number) => {
    if (next === tab) return;
    if (searchParams.has('page')) {
      searchParams.delete('page');
      setSearchParams(searchParams);
    }
    setTab(next);
  };

  const folders = [
    { label: 'Promos', icon: <GiftIcon/>, count: promoCount, countLabel: 'active', tone: '' },
    { label: 'Notifications', icon: <BellIcon/>, count: unreadNotifCount, countLabel: 'unread', tone: 'alert' },
  ];

  return (
    <div className="page lp-page">
      <Header header="News"/>
      <main className="lp-main">
        <div className="nw">
          {/* Folders, as in a mail app */}
          <nav className="nw-rail" aria-label="News folders">
            {folders.map((f, i) => (
              <button
                key={f.label}
                type="button"
                className={`nw-folder ${tab === i ? 'active' : ''}`}
                aria-current={tab === i ? 'page' : undefined}
                onClick={() => switchTab(i)}
              >
                <span className="nw-folder-icon" aria-hidden="true">{f.icon}</span>
                <span className="nw-folder-label">{f.label}</span>
                {f.count > 0 &&
                  <span className={`nw-folder-count ${f.tone}`}>
                    {f.count}<span className="visually-hidden"> {f.countLabel}</span>
                  </span>}
              </button>
            ))}
          </nav>

          {tab === 0 ? <PromosList /> : <NotificationsList />}
        </div>
      </main>
    </div>
  );
};

export default NewsPage;
